module.exports = __webpack_public_path__ + "static/media/number-of-sports-video.74985544.mp4";